/*
 * Generated on 11/29/2022, 9:24:44 AM
 * Do not edit this file, any changes will be overwritten
 */

"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * If question has been positively answered, go to url.
 */
function ask(question, url) {
  showConfirm({
    text: question,
    urlYes: url
  });
  return false; // if (confirm(question)) {
  //     document.location = url;
  // }
}
/**
 * General popup function. Popup will be centered in viewport.
 * @param url
 * @param name
 * @param width
 * @param height
 */


function popup(url, width, height, name) {
  var vWidth = $(window).width();
  var vHeight = $(window).height();
  if (typeof width == 'undefined') width = 800;
  if (typeof height == 'undefined') height = 600;
  if (typeof name == 'undefined') name = 'WebAdmin';
  var top = vHeight / 2 - height / 2;
  var left = vWidth / 2 - width / 2;
  window.open(url, name, 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=1,');
}

function openIframePopup(src) {
  var $modal = $('.popup-modal');
  var $iframe = $modal.find('iframe');
  src += src.indexOf('?') >= 0 ? '&' : '?';
  src += 'popup=1';
  $iframe.off('load').on('load', function () {
    var element = this;
    setTimeout(function () {
      var height = element.contentWindow.document.body.scrollHeight + 20;
      var maxHeight = $(window).height() - 80;
      var hasOverflow = false;

      if (height > maxHeight) {
        height = maxHeight;
        hasOverflow = true;
      }

      $iframe.animate({
        'height': height + 'px'
      }, 300, function () {
        $modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
        $iframe.removeClass('invisible');
        $iframe.contents().find('body').css({
          'height': '100%',
          'overflow': 'auto',
          '-webkit-overflow-scrolling': 'touch'
        });
      });
    }, 200);
  });
  $modal.modal('show');
  $modal.addClass('loading');
  $iframe.addClass('invisible').css({
    'height': '150px'
  }).attr('src', src);
}

function showAlert(alert, okText) {
  var $popin = $('.alert-popin');
  var $btn = $popin.find('.btn');

  if ($popin.is(':visible')) {
    return;
  }

  if (okText === undefined) {
    okText = $btn.data('text');
  }

  $btn.text(okText);
  $popin.find('.text').html(alert);
  $popin.modal({
    backdrop: 'static',
    keyboard: false
  });
}

function showConfirm(settings) {
  var $popin = $('.confirm-popin');
  settings = $.extend({
    text: '',
    textYes: $popin.find('.yes').data('text-yes'),
    textNo: $popin.find('.yes').data('text-no'),
    urlYes: '#',
    onConfirm: null,
    closeOnConfirm: true
  }, settings);

  if ($popin.is(':visible')) {
    return;
  }

  $popin.find('.text').html(settings.text);
  $popin.find('.yes').off('click').attr('href', settings.urlYes).text(settings.textYes);
  $popin.find('.no').text(settings.textNo);
  $popin.modal('show');
  $popin.find('.yes').on('click', function (e) {
    $popin.modal('hide');

    if (settings.onConfirm) {
      settings.onConfirm(e, $popin, settings);
    }
  });
}

function updateFileInputs() {
  $('.txtinput[type=file], .form-control[type=file]').each(function () {
    if ($(this).closest('.file-input').length > 0) {
      return;
    }

    $(this).wrap('<div class="file-input" />');
    var $parent = $(this).parent();
    $parent.append('<button type="button" class="btn"><i class="fa fa-file"></i> Choose file</button>');
    $parent.append('<input type="text" class="filename form-control" readonly>');
    $(this).on('change', function () {
      var file = $(this).get(0).files[0];
      $parent.find('.filename').val(file ? file.name : '');
    });
  });
}
/**
 * Get parameter value from url
 */


var QueryString = function () {
  var query_string = {};
  var query = window.location.search.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("="); // If first entry with this name

    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = pair[1]; // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      var arr = [query_string[pair[0]], pair[1]];
      query_string[pair[0]] = arr; // If third or later entry with this name
    } else {
      query_string[pair[0]].push(pair[1]);
    }
  }

  return query_string;
}();
/**
 * The equivalent of PHP's mktime function.
 * Usage: mktime( [ int hour [, int minute [, int second [, int month [, int day [, int year [, int is_dst]]]]]]] )
 */


function mktime() {
  var no = 0,
      i = 0,
      ma = 0,
      mb = 0,
      d = new Date(),
      dn = new Date(),
      argv = arguments,
      argc = argv.length;
  var dateManip = {
    0: function _(tt) {
      return d.setHours(tt);
    },
    1: function _(tt) {
      return d.setMinutes(tt);
    },
    2: function _(tt) {
      var set = d.setSeconds(tt);
      mb = d.getDate() - dn.getDate();
      return set;
    },
    3: function _(tt) {
      var set = d.setMonth(parseInt(tt, 10) - 1);
      ma = d.getFullYear() - dn.getFullYear();
      return set;
    },
    4: function _(tt) {
      return d.setDate(tt + mb);
    },
    5: function _(tt) {
      if (tt >= 0 && tt <= 69) {
        tt += 2000;
      } else if (tt >= 70 && tt <= 100) {
        tt += 1900;
      }

      return d.setFullYear(tt + ma);
    } // 7th argument (for DST) is deprecated

  };

  for (i = 0; i < argc; i++) {
    no = parseInt(argv[i] * 1, 10);

    if (isNaN(no)) {
      return false;
    } else {
      // arg is number, let's manipulate date object
      if (!dateManip[i](no)) {
        // failed
        return false;
      }
    }
  }

  for (i = argc; i < 6; i++) {
    switch (i) {
      case 0:
        no = dn.getHours();
        break;

      case 1:
        no = dn.getMinutes();
        break;

      case 2:
        no = dn.getSeconds();
        break;

      case 3:
        no = dn.getMonth() + 1;
        break;

      case 4:
        no = dn.getDate();
        break;

      case 5:
        no = dn.getFullYear();
        break;
    }

    dateManip[i](no);
  }

  return Math.floor(d.getTime() / 1000);
}
/**
 * This dump function is useful to print arrays and objects for
 * debugging purposes.
 */


function dump(arr, level) {
  var dumped_text = "";
  if (!level) level = 0; //The padding given at the beginning of the line.

  var level_padding = "";

  for (var j = 0; j < level + 1; j++) {
    level_padding += "    ";
  }

  if (_typeof(arr) == 'object') {
    //Array/Hashes/Objects
    for (var item in arr) {
      var value = arr[item];

      if (_typeof(value) == 'object') {
        //If it is an array,
        dumped_text += level_padding + "'" + item + "' ...\n";
        dumped_text += dump(value, level + 1);
      } else {
        dumped_text += level_padding + "'" + item + "' => \"" + value + "\"\n";
      }
    }
  } else {
    //Stings/Chars/Numbers etc.
    dumped_text = "===>" + arr + "<===(" + _typeof(arr) + ")";
  }

  return dumped_text;
}

function addslashes(str) {
  str = str.replace(/\\/g, '\\\\');
  str = str.replace(/\'/g, '\\\'');
  str = str.replace(/\"/g, '\\"');
  str = str.replace(/\0/g, '\\0');
  return str;
}

function stripslashes(str) {
  str = str.replace(/\\'/g, '\'');
  str = str.replace(/\\"/g, '"');
  str = str.replace(/\\0/g, '\0');
  str = str.replace(/\\\\/g, '\\');
  return str;
}

function keepAlive(keepalive_url) {
  $.ajax({
    url: keepalive_url,
    success: function success(data) {//alert(data);
    }
  });
}

var iconsMapping = new Map([//['imagename-no-extention', ['FontAwesome name',     'class']],
['warning_small', ['exclamation-triangle']], ['info_grey', ['info-circle']], ['folder_go', ['folder-open']], ['page_save', ['file-download']], ['page', ['file']], ['printer', ['print']], ['file_pdf', ['file-pdf']], ['cross', ['times-circle']], ['tick', ['check-circle']], ['cross_disabled', ['times-circle', 'disabled']], ['tick_disabled', ['check-circle', 'disabled']], ['flag_green', ['flag', 'green']], ['flag_pink', ['flag', 'pink']], ['flag_orange', ['flag', 'orange']], ['flag_purple', ['flag', 'purple']], ['flag_yellow', ['flag', 'yellow']], ['flag_red', ['flag', 'red']], ['flag_blue', ['flag', 'blue']], ['delete_disabled', ['trash-alt', 'disabled']], ['folder', ['folder']], ['page_add', ['plus']], ['page_edit', ['edit']], ['view', ['eye']], ['delete', ['trash-alt']], ['user_go', ['user']], ['group_edit', ['edit']], ['user_edit', ['edit']], ['file_doc', ['file-word']], ['warning', ['exclamation-triangle']], ['magnifier', ['search']], ['add', ['plus']], ['group_add', ['plus']], ['user_add', ['plus']], ['accept', ['check-circle']], ['arrow_refresh', ['sync']], ['arrow_rotate_clockwise', ['redo']], ['bullet_green', ['circle-small', 'green']], ['bullet_red', ['circle-small', 'red']], ['bullet_yellow', ['circle-small', 'yellow']], ['bullet_white', ['circle-small', 'gray']], ['bullet_toggle_minus', ['minus-circle']], ['bullet_toggle_plus', ['plus']], ['chart_bar', ['chart-bar']], ['chart_curve', ['chart-line']], ['chart_pie', ['chart-pie']], ['clipboard', ['clipboard']], ['control_play_blue', ['play-circle', 'blue']], ['control_play', ['play-circle']], ['control_stop_blue', ['stop-circle', 'blue']], ['control_stop', ['stop-circle']], ['disk', ['save']], ['downward', ['caret-down']], ['email_add', ['plus']], ['email_go', ['paper-plane']], ['file_doc', ['file-word']], ['file_docx', ['file-word']], ['file_gif', ['file-image']], ['file_jpg', ['file-image']], ['file_pdf', ['file-pdf']], ['file_png', ['file-image']], ['file_ppt', ['file-powerpoint']], ['file_txt', ['file-lines']], ['file_unknown', ['file']], ['file_xls', ['file-spreadsheet']], ['file_xlsx', ['file-spreadsheet']], ['folder_explore', ['search']], ['group_key', ['key']], ['hourglass', ['hourglass']], ['image_edit', ['edit']], ['info', ['info-circle']], ['link_break', ['unlink']], ['link_delete', ['trash-alt']], ['link_go', ['check-circle']], ['link', ['link']], ['lock', ['lock']], ['move', ['arrows']], ['order_white_asc', ['chevron-up']], ['order_white_desc', ['chevron-down']], ['package_add', ['plus']], ['package_go', ['shipping-fast']], ['page_delete', ['trash-alt']], ['picture_edit', ['edit']], ['picture_go', ['check-circle']], ['resultset_first', ['step-backward']], ['resultset_last', ['step-forward']], ['resultset_next_multi', ['forward']], ['resultset_next', ['play']], ['resultset_previous_multi', ['backward']], ['resultset_previous', ['backward-step']], ['table_delete', ['trash']], ['table_go', ['check-circle']], ['table_save', ['save']], ['time_add', ['plus']], ['time_go', ['check-circle']], ['time', ['clock']], ['upward', ['caret-up']]]);

function replaceIcon($img) {
  var imgpath = $img.attr('src');
  var lastSlash = imgpath.lastIndexOf('/');
  var imgfile = imgpath.substring(lastSlash + 1);
  var filename = imgfile.split('.')[0];

  if (iconsMapping.has(filename)) {
    var replacement = iconsMapping.get(filename);
    var icon = replacement[0];
    var iconClass = replacement[1] || '';
    var $icon = $('<i class="fa fa-' + (icon + ' ' + iconClass).trim() + '">');
    $icon.attr('title', $img.attr('title'));
    $img.wrap($icon);
    $img.remove();
  } else {
    console.warn('no icon found for', filename);
  }
}

function replaceIcons($images) {
  $images.filter('[src*="assets/img/icons/"]').each(function () {
    replaceIcon($(this));
  });
  $images.filter('[src*="/admin_assets/icons/"]').each(function () {
    replaceIcon($(this));
  });
  $images.filter('[src*="assets/img/warning"]').each(function () {
    replaceIcon($(this));
  });
}

var iconObserver = new MutationObserver(function (mutationsList, observer) {
  var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var mutation = _step.value;

      var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          var $images = $(node).filter('img');
          if ($images.length === 0) $images = $(node).find('img');
          if ($images.length) replaceIcons($images);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});
iconObserver.observe(document, {
  childList: true,
  subtree: true
});
$(function () {
  replaceIcons($('img'));
});